import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({
  checked, label, onChange, strong, onClickLabel, spanText, children,
}) => (
  <div className="checkbox">
    <input
      type="checkbox"
      defaultChecked={checked}
    />
    <div className="content-checkbox">
      <label onClick={() => onChange(!checked)} />
      {
        children
        ?? (
          <p className={strong ? 'strong' : ''}>
            {label}
            {spanText && <span onClick={() => onClickLabel()}>{spanText}</span>}
          </p>
        )
      }
    </div>
  </div>
);

Checkbox.defaultProps = {
  checked: false,
  strong: false,
  onClickLabel: () => {},
  spanText: '',
  children: null,
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  strong: PropTypes.bool,
  onClickLabel: PropTypes.func,
  spanText: PropTypes.string,
  children: PropTypes.node,
};

export default Checkbox;
